import { Controller } from '@hotwired/stimulus'
import { currentLocation, renderWalkResponse, sendJSON } from '../lib/prayer_walk'

export default class extends Controller {
  static targets = ['status']

  async start (event) {
    event.preventDefault()
    if (this.starting) return
    this.starting = true
    const button = this.element.querySelector('[type="submit"]')
    button.disabled = true
    this.statusTarget.textContent = 'Getting your starting location…'
    const startedAt = new Date().toISOString()
    try {
      const location = await currentLocation()
      this.statusTarget.textContent = location ? 'Starting your walk…' : 'Starting without GPS. Your time will still be recorded.'
      const componentId = this.element.querySelector('[name="prayer_walk[component_id]"]').value
      const result = await sendJSON(this.element.action, 'POST', {
        prayer_walk: { component_id: componentId, started_at: startedAt, start_location: location }
      })
      renderWalkResponse(result)
    } catch (error) {
      this.statusTarget.textContent = error.message
    } finally {
      this.starting = false
      button.disabled = false
    }
  }
}
